const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  name: (state) => state.user.name,
  isNewVersion: (state) => state.app.isNewVersion,
  permissionCodes: (state) => state.app.permissionCodes,
  contractDetail: (state) => state.app.contractDetail // 合约项目列表-详情
};
export default getters;
